import { z } from 'zod'

import { axios, Response } from '..'

export const GetDriveEditableUrlDTO = z.object({
  fileName: z.string(),
  documentId: z.string(),
  targetId: z.string().optional(),
  fileUrl: z.string()
})
export type GetDriveEditableUrlDTO = z.infer<typeof GetDriveEditableUrlDTO>

export const DriveEditableUrl = z.object({
  linkResponse: z.string(),
  isReport: z.boolean(),
  type: z.enum(['DEFAULT', 'EDITOR', 'REVIEWER'])
})
export type DriveEditableUrl = z.infer<typeof DriveEditableUrl>

export default async function getDriveEditableUrl(
  body: GetDriveEditableUrlDTO
): Response<DriveEditableUrl> {
  const response = await axios.post(`v2/generated-drive-url`, body)
  return response
}
